import React from "react";
import styled from "styled-components";
import Cross from "./icons/Cross";
const StyledCloseButton = styled.button `
  position: relative;
  padding: 10px;
  width: 30px;
  height: 30px;
  background-color: ${props => {
    if (props.primary) {
        return props.theme.primary;
    }
    return "rgba(255, 255, 255, .2)";
}};
  border: none;
  border-radius: 50%;
  cursor: pointer;

  &:focus,
  &:hover {
    background-color: ${props => {
    if (props.primary) {
        return props.theme.hover;
    }
    return "rgba(255, 255, 255, .1)";
}};
  }
`;
const StyledCross = styled(Cross) `
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  fill: white;
  width: 11px;
  height: 11px;
`;
const ButtonWrapper = styled.div `
  display: flex;
  align-items: center;
  cursor: pointer;
`;
const CloseButton = ({ className, primary, onClick, children, }) => (React.createElement(ButtonWrapper, { onClick: onClick },
    children,
    React.createElement(StyledCloseButton, { className: className, primary: primary },
        React.createElement(StyledCross, null))));
export default CloseButton;
